import axios from 'axios'
import store from '@/store/index.js'

axios.defaults.baseURL =
  process.env.NODE_ENV === 'production'
    ? 'http://175.125.95.175/promgmtapi'
    : 'http://127.0.0.1:28888/promgmtapi'

let subscribers = []

function onAccessTokenFetched (accessToken) {
  subscribers = subscribers.filter((callback) => callback(accessToken))
}

function addSubscriber (callback) {
  subscribers.push(callback)
}

// Add a request interceptor
axios.interceptors.request.use(
  (config) => {
    // Do something before request is sent
    if (store.getters.isAuthenticated) {
      const accessToken = store.getters.getAccessToken

      config.headers.Authorization = `Bearer ${accessToken}`
    }

    return config
  },
  (error) =>
    // Do something with request error
    Promise.reject(error)
)

// Add a response interceptor
axios.interceptors.response.use(
  function (response) {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data

    return response
  },
  async function (error) {
    const {
      config,
      response: { status }
    } = error
    const originalRequest = config

    if (status === 401) {
      store.dispatch('refreshToken').then(
        (response) => {
          const accessToken = response.accessToken
          onAccessTokenFetched(accessToken)
        },
        () => {
          location.href = '/'
        }
      )

      const retryOriginalRequest = new Promise((resolve) => {
        addSubscriber((accessToken) => {
          originalRequest.headers.Authorization = `Bearer  ${accessToken}`
          resolve(axios(originalRequest))
        })
      })

      return retryOriginalRequest
    } else if (status === 403) {
      location.href = '/403'
    } else if (status === 404) {
      location.href = '/404'
    } else {
      return Promise.reject(error)
    }
  }
)

export default axios
